import { Button } from 'components/ui';
import { Popup } from 'react-mapbox-gl';
import styled from 'styled-components';
import { breakpoints } from 'styles/theme';

const offset: any = {
  bottom: [0, -60],
  'bottom-left': [0, -60],
  'bottom-right': [0, -60],
  top: [0, 10],
  'top-left': [0, 10],
  'top-right': [0, 10],
};

export const Tooltip = styled(Popup).attrs({
  offset,
})`
  width: 80%;
  max-width: 416px;
  background: none;
  filter: drop-shadow(0 4px 9px rgba(0, 0, 0, 0.16));

  @media screen and (max-width: ${breakpoints.medium}) {
    ${Button} {
      padding: var(--space-0);
      font-size: var(--font-size-xxx-small);
    }
  }

  @media screen and (min-width: ${breakpoints.medium}) {
    width: 50%;
  }

  .mapboxgl-popup-content {
    padding: var(--space-1);
    font-size: var(--font-size-xxx-small);
    font-family: var(--font-body);
    border-radius: 0;
    box-shadow: 0 32px 64px rgba(17, 17, 17, 0.08);

    @media screen and (min-width: ${breakpoints.medium}) {
      padding: var(--space-3);
      font-size: var(--font-size-xx-small);
    }
  }

  .mapboxgl-popup-tip {
    border-width: 18px;
  }
`;
